/**
 * lib/sonde.ts — sondes côté téléphone (09/10) : mises en file, envoyées par lot
 * toutes les 10 s et quand l'app passe en arrière-plan (sendBeacon survit à la
 * fermeture). Session aléatoire par onglet ; aucune identité de compte.
 */
type Ev = { type: string; props: Record<string, unknown> };
const file: Ev[] = [];
let minuteur: ReturnType<typeof setTimeout> | null = null;

function session(): string {
  try {
    let s = sessionStorage.getItem('ogryn.sonde');
    if (!s) { s = crypto.randomUUID(); sessionStorage.setItem('ogryn.sonde', s); }
    return s;
  } catch { return 'sans-session'; }
}

export function envoyerSondes(): void {
  if (minuteur) { clearTimeout(minuteur); minuteur = null; }
  if (!file.length) return;
  const corps = JSON.stringify({ session: session(), evenements: file.splice(0, 20) });
  try {
    if (!navigator.sendBeacon?.('/api/evenements', new Blob([corps], { type: 'application/json' }))) {
      void fetch('/api/evenements', { method: 'POST', body: corps, keepalive: true }).catch(() => {});
    }
  } catch { /* la collecte ne casse jamais l'app */ }
  if (file.length) minuteur = setTimeout(envoyerSondes, 10_000);
}

export function sonde(type: string, props: Record<string, unknown>): void {
  file.push({ type, props });
  if (file.length >= 20) envoyerSondes();
  else if (!minuteur) minuteur = setTimeout(envoyerSondes, 10_000);
}
